module.exports = __webpack_public_path__ + "media/3.9034fb4b.wav";